var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolUltrasoundBidirectional = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "square",
  d: "M4 17.5v6M4.5 23.5h6"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  cx: 4,
  cy: 15.5,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  cx: 12.5,
  cy: 23.5,
  r: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  x: 8,
  y: 4,
  width: 17,
  height: 10,
  rx: 2
}), /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.762 11.172c-.66 0-1.098-.395-1.098-1.121V6.668h-1.059v3.492c0 1.168.844 1.942 2.157 1.942 1.308 0 2.152-.774 2.152-1.942V6.668h-1.059v3.383c0 .722-.437 1.12-1.093 1.12ZM16.86 10.531c.046.844.703 1.57 2.058 1.57 1.352 0 2.113-.683 2.113-1.683 0-.906-.57-1.32-1.433-1.512l-.828-.183c-.47-.098-.73-.301-.73-.618 0-.398.347-.69.929-.69.566 0 .914.292.98.663h1c-.05-.824-.754-1.52-1.972-1.52-1.176 0-1.993.637-1.993 1.626 0 .824.524 1.293 1.352 1.48l.824.188c.555.125.82.308.82.671 0 .422-.347.715-1.003.715-.63 0-1.028-.304-1.098-.707h-1.02Z"
})))));
export { SvgToolUltrasoundBidirectional as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-ultrasound-bidirectional.svg";